module.exports = __webpack_public_path__ + "img/ht.73aa4ead.svg";